import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'

export const WrapSize = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const InfoImage = styled.div`
  display: flex;
  min-width: 50%;
  justify-content: center;
  align-items: center;
`

export const Img = styled(ResponsiveImage)`
  width: 70vw;

  @media screen and (min-width: 768px) {
    width: 100%;
  }
`

export const Info = styled.div`
  margin-bottom: 3rem;
  column-gap: 2rem;

  @media screen and (min-width: 768px) {
    display: flex;
    flex-direction: row;
    margin-bottom: 6rem;
  }
`

export const MeasuresList = styled.ul`
  list-style-type: none;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 0;
  margin: 1rem;

  @media screen and (min-width: 768px) {
    margin-bottom: 2rem;
  }
`

export const InfoText = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 3rem;

  @media screen and (min-width: 768px) {
    margin: 0;
    justify-content: center;
  }
`

export const Measure = styled.li`
  display: flex;
  margin: 0;
  align-items: center;
  justify-content: center;
`

export const Circle = styled.div`
  display: flex;
  min-width: 2rem;
  min-height: 2rem;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.danger};
  border-radius: 50%;
`
